module.exports = "<li role=menuitem><a ng-href={{href}} ng-transclude></a></li>";